export default __webpack_public_path__ + "static/media/rocket.db9b2a06.png";